import React from 'react';
import './stylesEtiquetasMasc.css';
import Eti101RF from '../../imagens/etiquetas/eti101RF.png';
import Eti111 from '../../imagens/etiquetas/eti111.png';
import Eti112 from '../../imagens/etiquetas/eti112.png';
import Eti113 from '../../imagens/etiquetas/eti113.png';
import Eti114 from '../../imagens/etiquetas/eti114.png';
import Eti115 from '../../imagens/etiquetas/eti115.png';
import Eti201 from '../../imagens/etiquetas/eti201.png';
import Eti202 from '../../imagens/etiquetas/eti202.png';
import Eti203 from '../../imagens/etiquetas/eti203.png';
import Eti204 from '../../imagens/etiquetas/eti204.png';
import Eti205 from '../../imagens/etiquetas/eti205.png';
import Eti206 from '../../imagens/etiquetas/eti206.png';
import Eti208 from '../../imagens/etiquetas/eti208.png';
import Eti211 from '../../imagens/etiquetas/eti211.png';
import Eti215 from '../../imagens/etiquetas/eti215.png';
import Eti217T from '../../imagens/etiquetas/eti217T.png';
import Eti216 from '../../imagens/etiquetas/eti216.png';
import Eti218 from '../../imagens/etiquetas/eti218.png';
import Eti221 from '../../imagens/etiquetas/eti221.png';
import Eti231 from '../../imagens/etiquetas/eti231.png';
import Eti250 from '../../imagens/etiquetas/eti250.png';
import Eti270T from '../../imagens/etiquetas/eti270T.png';
import Eti295T from '../../imagens/etiquetas/eti295T.png';
import Eti296T from '../../imagens/etiquetas/eti296T.png';
import Eti297T from '../../imagens/etiquetas/eti297T.png';
import Eti298 from '../../imagens/etiquetas/eti298.png';
import Eti299 from '../../imagens/etiquetas/eti299.png';
import Eti301 from '../../imagens/etiquetas/eti301.png';
import Eti302 from '../../imagens/etiquetas/eti302.png';
import Eti303 from '../../imagens/etiquetas/eti303.png';
import Eti304 from '../../imagens/etiquetas/eti304.png';
import Eti305 from '../../imagens/etiquetas/eti305.png';
import Eti306 from '../../imagens/etiquetas/eti306.png';
import Eti307 from '../../imagens/etiquetas/eti307.png';
import Eti308 from '../../imagens/etiquetas/eti308.png';
import Eti309 from '../../imagens/etiquetas/eti309.png';
import Eti311 from '../../imagens/etiquetas/eti311.png';
import Eti312 from '../../imagens/etiquetas/eti312.png';
import Eti313 from '../../imagens/etiquetas/eti313.png';
import Eti314 from '../../imagens/etiquetas/eti314.png';
import Eti318T from '../../imagens/etiquetas/eti318T.png';
import Eti320 from '../../imagens/etiquetas/eti320.png';
import Eti321 from '../../imagens/etiquetas/eti321.png';
import Eti322 from '../../imagens/etiquetas/eti322.png';
import Eti330 from '../../imagens/etiquetas/eti330.png';
import Eti331 from '../../imagens/etiquetas/eti331.png';
import Eti901 from '../../imagens/etiquetas/eti901.png';
import Eti902 from '../../imagens/etiquetas/eti902.png';
import Eti904 from '../../imagens/etiquetas/eti904.png';

const EtiquetasMasc = () => {
    const sections = [
        {
            titulo: '1 Coluna - Tamanho 40x25mm',
            etiquetas: [
                {
                    modelo: 'Modelo 114',
                    image: Eti114,
                    texts: [
                        '114 - Impressão Direta',
                    ],
                },
                {
                    modelo: 'Modelo 115',
                    image: Eti115,
                    texts: [
                        '115 - Impressão Direta',
                    ],
                },
            ],
        },
        {
            titulo: '1 Coluna - Tamanho 50x25mm',
            etiquetas: [
                {
                    modelo: 'Modelo 113',
                    image: Eti113,
                    texts: [
                        '113 - Impressão Direta',
                        'E113 - Linguagem EPL - PPLB',
                        'Z113 - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },
        {
            titulo: '1 Coluna - Tamanho 50x30mm',
            etiquetas: [
                {
                    modelo: 'Modelo 111',
                    image: Eti111,
                    texts: [
                        '111 - Impressão Direta',
                        'E111 - Linguagem EPL - PPLB',
                        'Z111 - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },

        {
            titulo: '1 Coluna - Tamanho 60x40mm',
            etiquetas: [
                {
                    modelo: 'Modelo 112',
                    image: Eti112,
                    texts: [
                        '112 - Impressão Direta',
                    ],
                },
            ],
        },

        {
            titulo: '1 Coluna - Tamanho 72x19mm - RFID',
            etiquetas: [
                {
                    modelo: 'Modelo 101RF',
                    image: Eti101RF,
                    texts: [
                        'Z101RF - Linguagem ZPL',
                    ],
                },
            ],
        },

        {
            titulo: '2 Colunas - Tamanho 36x54mm',
            etiquetas: [
                {
                    modelo: 'Modelo 298',
                    image: Eti298,
                    texts: [
                        'E298 - Linguagem EPL - PPLB',
                        'Z298 - Linguagem ZPL - PPLZ',
                        {
                            tipo: 'nota',
                            titulo: 'Impressão da logomarca disponível apenas para ZPL:',
                            itens: [
                                'Formato: PNG com fundo transparente',
                                'Tamanho máximo: 272 x 120 pixels',
                                'Cor: recomenda-se o uso de preto — outras cores podem comprometer a nitidez da impressão',
                            ],
                        },
                    ],
                },

                {
                    modelo: 'Modelo 299',
                    image: Eti299,
                    texts: [
                        'E299 - Linguagem EPL - PPLB',
                        'Z299 - Linguagem ZPL - PPLZ',
                        {
                            tipo: 'nota',
                            titulo: 'Impressão da logomarca disponível apenas para ZPL:',
                            itens: [
                                'Formato: PNG com fundo transparente',
                                'Tamanho máximo: 272 x 120 pixels',
                                'Cor: recomenda-se o uso de preto — outras cores podem comprometer a nitidez da impressão',
                            ],
                        },
                    ],
                },
            ],
        },

        {
            titulo: '2 Colunas - Tamanho 40x25mm',
            etiquetas: [
                {
                    modelo: 'Modelo 215',
                    image: Eti215,
                    texts: [
                        ' 215 - Impressão Direta',
                        'E215 - Linguagem EPL - PPLB',
                        'Z215 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 218',
                    image: Eti218,
                    texts: [
                        '218 - Impressão Direta',
                    ],
                },
            ],
        },

        {
            titulo: '2 Colunas - Tamanho 40x55mm',
            etiquetas: [
                {
                    modelo: 'Modelo 216',
                    image: Eti216,
                    texts: [
                        '216 - Impressão Direta',
                    ],
                },
                {
                    modelo: 'Modelo 217T',
                    image: Eti217T,
                    texts: [
                        ' 217T - Impressão Direta',
                        'E217T - Linguagem EPL - PPLB',
                        'Z217T - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },

        {

            titulo: '2 Colunas - Tamanho 50x25mm',
            etiquetas: [
                {
                    modelo: 'Modelo 221',
                    image: Eti221,
                    texts: [
                        'E221 - Linguagem EPL - PPLB',
                        'Z221 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 231',
                    image: Eti231,
                    texts: [
                        'E231 - Linguagem EPL - PPLB',
                        'Z231 - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },

        {
            titulo: '2 Colunas - Tamanho 50x27mm',
            etiquetas: [
                {
                    modelo: 'Modelo 201',
                    image: Eti201,
                    texts: [
                        ' 201 - Impressão Direta',
                        'A201 - Linguagem PPLA • Argox',
                        'E201 - Linguagem EPL - PPLB',
                        'Z201 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 202',
                    image: Eti202,
                    texts: [
                        'A202 - Linguagem PPLA • Argox',
                        'E202 - Linguagem EPL - PPLB',
                        'Z202 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 203',
                    image: Eti203,
                    texts: [
                        'E203 - Linguagem EPL - PPLB',
                        'Z203 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 204',
                    image: Eti204,
                    texts: [
                        'E204 - Linguagem EPL - PPLB',
                        'Z204 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 205',
                    image: Eti205,
                    texts: [
                        'E205 - Linguagem EPL - PPLB',
                        'Z205 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 206',
                    image: Eti206,
                    texts: [
                        'E206 - Linguagem EPL - PPLB',
                        'Z206 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 208',
                    image: Eti208,
                    texts: [
                        ' 208 - Impressão Direta',
                        'E208 - Linguagem EPL - PPLB',
                        'Z208 - Linguagem ZPL - PPLZ',
                    ],
                },


                {
                    modelo: 'Modelo 904',
                    image: Eti904,
                    texts: [
                        'E904 - Linguagem EPL - PPLB',
                    ],
                },
            ],
        },

        {
            titulo: '2 Colunas - Tamanho 50x30mm',
            etiquetas: [
                {
                    modelo: 'Modelo 211',
                    image: Eti211,
                    texts: [
                        'E211 - Linguagem EPL - PPLB',
                    ],
                },
            ],
        },

        {
            titulo: '2 Colunas - Tamanho 50x50mm',
            etiquetas: [
                {
                    modelo: 'Modelo 250',
                    image: Eti250,
                    texts: [
                        '250 - Impressão Direta',
                    ],
                },
            ],
        },

        {
            titulo: '2 Colunas - Tamanho 50x75mm',
            etiquetas: [
                {
                    modelo: 'Modelo 270T',
                    image: Eti270T,
                    texts: [
                        '270T - Impressão Direta',
                        'E270T - Linguagem EPL - PPLB',
                        'Z270T - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 295T',
                    image: Eti295T,
                    texts: [
                        '295T - Impressão Direta',
                    ],
                },
                {
                    modelo: 'Modelo 296T',
                    image: Eti296T,
                    texts: [
                        '296T - Impressão Direta',
                        'Z296T - Linguagem ZPL - PPLZ',
                         {
                            tipo: 'nota',
                            titulo: 'Impressão da logomarca disponível apenas para ZPL:',
                            itens: [
                                'Formato: PNG com fundo transparente',
                                'Tamanho máximo: 400 x 120 pixels',
                                'Cor: recomenda-se o uso de preto — outras cores podem comprometer a nitidez da impressão',
                            ],
                        },
                    ],
                },
                {
                    modelo: 'Modelo 297T',
                    image: Eti297T,
                    texts: [
                        'E297T - Linguagem EPL - PPLB',
                        'Z297T - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },
     

        {
            titulo: '3 Colunas - Tamanho 33x21mm',
            etiquetas: [
                {
                    modelo: 'Modelo 301',
                    image: Eti301,
                    texts: [
                        ' 301 - Impressão Direta',
                        'A301 - Linguagem PPLA • Argox',
                        'E301 - Linguagem EPL - PPLB',
                        'Z301 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 302',
                    image: Eti302,
                    texts: [
                        'A302 - Linguagem PPLA • Argox',
                        'E302 - Linguagem EPL - PPLB',
                        'Z302 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 303',
                    image: Eti303,
                    texts: [
                        'A303 - Linguagem PPLA • Argox',
                        'E303 - Linguagem EPL - PPLB',
                        'Z303 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 304',
                    image: Eti304,
                    texts: [
                        'E304 - Linguagem EPL - PPLB',
                        'Z304 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 305',
                    image: Eti305,
                    texts: [
                        'E305 - Linguagem EPL - PPLB',
                        'Z305 - Linguagem ZPL - PPLZ',
                    ],
                },

                {
                    modelo: 'Modelo 306',
                    image: Eti306,
                    texts: [
                        ' 306 - Impressão Direta',
                        'E306 - Linguagem EPL - PPLB',
                        'Z306 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 307',
                    image: Eti307,
                    texts: [
                        '307 - Impressão Direta',
                    ],
                },
                {
                    modelo: 'Modelo 308',
                    image: Eti308,
                    texts: [
                        '308 - Impressão Direta',
                    ],
                },
                {
                    modelo: 'Modelo 309',
                    image: Eti309,
                    texts: [
                        '309 - Impressão Direta',
                    ],
                },
            ],
        },

        {
            titulo: '3 Colunas - Tamanho 33x60mm',
            etiquetas: [
                {
                    modelo: 'Modelo 311',
                    image: Eti311,
                    texts: [
                        'E311 - Linguagem EPL - PPLB',
                        'Z311 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 312',
                    image: Eti312,
                    texts: [
                        'E312 - Linguagem EPL - PPLB',
                        'Z312 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 313',
                    image: Eti313,
                    texts: [
                        ' 313 - Impressão Direta',
                        'E313 - Linguagem EPL - PPLB',
                        'Z313 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 314',
                    image: Eti314,
                    texts: [
                        'E314 - Linguagem EPL - PPLB',
                        'Z314 - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },

        {
            titulo: '3 Colunas - Tamanho 34x23mm',
            etiquetas: [
                {
                    modelo: 'Modelo 330',
                    image: Eti330,
                    texts: [
                        ' 330 - Impressão Direta',
                        'E330 - Linguagem EPL - PPLB',
                        'Z330 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 331',
                    image: Eti331,
                    texts: [
                        '331 - Impressão Direta',
                        'E331 - Linguagem EPL - PPLB',
                        'Z331 - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },

        {
            titulo: '3 Colunas - Tamanho 35x30mm',
            etiquetas: [
                {
                    modelo: 'Modelo 320',
                    image: Eti320,
                    texts: [
                        ' 320 - Impressão Direta',
                        'E320 - Linguagem EPL - PPLB',
                        'Z320 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 321',
                    image: Eti321,
                    texts: [
                        ' 321 - Impressão Direta',
                        'E321 - Linguagem EPL - PPLB',
                        'Z321 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 322',
                    image: Eti322,
                    texts: [
                        ' 322 - Impressão Direta',
                        'E322 - Linguagem EPL - PPLB',
                        'Z322 - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },

        {
            titulo: '3 Colunas - Tamanho 35x60mm',
            etiquetas: [
                {
                    modelo: 'Modelo 318T',
                    image: Eti318T,
                    texts: [
                        '318T - Impressão Direta',
                    ],
                },
            ],
        },


        {
            titulo: 'Acessórios - Tamanho 30x12mm - Alça na Direita',
            etiquetas: [
                {
                    modelo: 'Modelo 901',
                    image: Eti901,
                    texts: [
                        ' 901 - Impressão Direta',
                        'E901 - Linguagem EPL - PPLB',
                        'Z901 - Linguagem ZPL - PPLZ',
                    ],
                },
                {
                    modelo: 'Modelo 902',
                    image: Eti902,
                    texts: [
                        'E902 - Linguagem EPL - PPLB',
                        'Z902 - Linguagem ZPL - PPLZ',
                    ],
                },
            ],
        },
    ];

    return (
        <div className="etiquetas-content">
            {sections.map((section, index) => (
                <div key={index} className="etiquetas-section-group">
                    <h2 className="etiquetas-section-titulo">{section.titulo}</h2>
                    <div className="etiquetas-section">
                        {section.etiquetas.map((etiqueta, i) => (
                            <div className="etiqueta-card" key={i}>
                                <h3 className="etiqueta-modelo">{etiqueta.modelo}</h3>
                                <div className="etiqueta-conteudo">
                                    <img src={etiqueta.image} alt={etiqueta.modelo} className="etiqueta-imagem" />
                                    <div className="etiqueta-textos">
                                        {etiqueta.texts
                                            .filter(item => typeof item !== 'string' || item.trim() !== '')
                                            .map((item, j) =>
                                                typeof item === 'object' && item.tipo === 'nota' ? (
                                                    <div key={j} className="etiqueta-nota">
                                                        <p className="etiqueta-nota__titulo">{item.titulo}</p>
                                                        <ul className="etiqueta-nota__lista">
                                                            {item.itens.map((it, k) => (
                                                                <li key={k}>{it}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ) : (
                                                    <p key={j} className="etiqueta-texto">{item}</p>
                                                )
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default EtiquetasMasc;
